<template>
  <div class="container">
<QueryFrame
@handlePage='handlePage' @handlePageSize='handlePageSize' :disablePage='disablePage'
      :current='page' :count='count'
>
<div slot="queryParams" class="queryContainer">
 <div class="queryItem" v-if="roleType!==2">
            <label>创建门店:</label>
            <StoreListSelect :maxlength='100' placeholder='请输入' class="item" clearable
              v-model.trim='query.storeIdList'></StoreListSelect>
          </div>
 <goodsSearchItem class="queryItem" v-model="query.nameMix"></goodsSearchItem>
          <div class="queryItem">
            <label>开始用药时间:</label>
            <timeStampDatePicker type='daterange' :maxlength='100' placeholder='请输入' class="item"
              clearable v-model.trim='query.usageStartTime'></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>计划复购日期:</label>
            <timeStampDatePicker type='daterange' :maxlength='100' placeholder='请输入' class="item"
              clearable v-model.trim='query.planRebuyTime'></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
</div>


<div  slot='table'>
  <div class="tableContainer">
<div class='btns'>
<DownloadButton @on-click="download" v-if="handlePermission('downLoadPatientRebuyListReason')"/>
</div>
<lk-table :columns='columns' :data='tableData' border></lk-table>
  </div>

</div>
</QueryFrame>
<lk-modal title="编辑未复购原因" v-model="editModal" :mask-closable='false'>
  <div>
    <lk-form :model="reasonForm" :label-width='110' label-position="right" :rules='validate' ref="reasonForm">
      <!-- 是否复购1、未复购原因1、是否复购2、未复购原因2、是否复购3、未复购原因3 -->
      <div v-for="part in [1,2,3]" :key="part">

      <lk-row :gutter='16'  >
        <lk-col>
          <lk-form-item :label='`是否复购${part}:`'>
             <lk-select v-model="reasonForm['recall'+part]" @on-change='handleValid($event,part)' clearable>
              <lk-option v-for='(item,i) in judgeList' :key="i" :value="+i">{{item}}</lk-option>
            </lk-select>
          </lk-form-item>
        </lk-col>
      </lk-row>
      <lk-row :gutter='16' label-position="right">
        <lk-col>
          <lk-form-item :label='`未复购原因${part}:`' :prop='"reason"+part' :class='{"ivu-form-item-required":validate["reason"+part]&&validate["reason"+part][0].required}'>
            <lk-select v-model="reasonForm['reason'+part]" clearable>
              <lk-option v-for='item in reasonList' :key="item.value" :value="+item.value">{{item.title}}</lk-option>
            </lk-select>
          </lk-form-item>
        </lk-col>
      </lk-row>
      <lk-row :gutter='16'>
         <lk-col>
           <lk-form-item :label='`回访备注${part}:`'>
             <lk-input type='textarea' :maxlength='200' v-model="reasonForm['remark'+part]">
             </lk-input>
           </lk-form-item>
         </lk-col>
      </lk-row>
      </div>
    </lk-form>
  </div>
<div slot='footer'>
  <lk-button @click='editModal=false' :loading='modalLoading'>取消</lk-button>
  <lk-button type='primary' @click='handleSubmit' :loading='modalLoading'>确定</lk-button>
</div>
</lk-modal>
  </div>
</template>

<script>
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import goodsSearchItem from '../../../components/goodsSearchItem.vue';
import DownloadButton from '../../../components/download/DownloadButton.vue';
import queryMixins from '../../../mixins/queryMixins.js';
import mapState from '../../../mixins/mapState.js';
import base from '../../../services/base';
import utils from '../../../libs/utils.js';

export default {
  name: 'noRebuyReason',
  components: {
    QueryFrame, DownloadButton, goodsSearchItem,
  },
  mixins: [queryMixins, mapState],
  computed: {
    reasonList() {
      return this.$store.getters.getNoRebuyReason;
    },
    judgeList() {
      return this.$store.state.publicParams.judgeList;
    },
  },
  data() {
    return {
      query: {
        usageStartTime: [], // 开始用药时间
        planRebuyTime: [], // 计划复购日期
      },
      modalLoading: false,
      validate: {},
      reasonForm: {},
      editModal: false,
      tableData: [],
      columns: [
        {
          title: '门店名称', key: 'storeName', minWidth: 116, tooltip: true,
        },
        {
          title: '患者姓名', key: 'patientName', minWidth: 116, tooltip: true,
        },
        {
          title: '商品名称', key: 'goodsName', minWidth: 116, tooltip: true,
        },
        {
          title: '手机号', key: 'patientPhone', minWidth: 116, tooltip: true,
        },
        {
          title: '开始用药时间', key: 'usageStartTime', minWidth: 116, tooltip: true,
        },
        {
          title: '用药周期', key: 'usageCycle', minWidth: 116, tooltip: true,
        },
        {
          title: '计划复购日期', key: 'planRebuyTime', minWidth: 116, tooltip: true,
        },
        {
          title: '状态', key: 'statusStr', minWidth: 116, tooltip: true,
        },
        {
          title: '是否复购1', key: 'recall1Str', minWidth: 116, tooltip: true,
        },
        {
          title: '未复购原因1', key: 'reason1Str', minWidth: 116, tooltip: true,
        },
        {
          title: '是否复购2', key: 'recall2Str', minWidth: 116, tooltip: true,
        },
        {
          title: '未复购原因2', key: 'reason2Str', minWidth: 116, tooltip: true,
        },
        {
          title: '是否复购3', key: 'recall3Str', minWidth: 116, tooltip: true,
        },
        {
          title: '未复购原因3', key: 'reason3Str', minWidth: 116, tooltip: true,
        },
        {
          title: '操作',
          key: 'storeName',
          fixed: 'right',
          minWidth: 116,
          tooltip: true,
          render: (h, { row }) => h('lk-button', {
            props: {
              type: 'text',
              size: 'small',
            },
            on: {
              click: () => {
                console.log(row);
                this.$refs.reasonForm.resetFields();
                this.editModal = true;
                this.reasonForm = row;
              },
            },
          }, '去处理'),
        },

      ],
    };
  },
  methods: {
    formatParams(params) { // 将传递的参数转成后端可以接受的类型
      const temp = utils.deepClone(params);
      temp.page = this.page;
      temp.size = this.size;
      if (temp.usageStartTime.length) {
        temp.usageStartTimeStart = temp.usageStartTime[0]; // 开始用药时间的开始日期
        temp.usageStartTimeEnd = temp.usageStartTime[1]; // 开始用药时间的截止日期
      }
      if (temp.planRebuyTime.length) {
        temp.planRebuyTimeStart = temp.planRebuyTime[0]; // 复购开始日期
        temp.planRebuyTimeEnd = temp.planRebuyTime[1]; // 复购截止日期
      }
      return temp;
    },
    clear() {
      this.query = {};
    },
    download() {
      const params = utils.deepClone(this.params);
      params.queryCondition = utils.getQueryCondition('.queryContainer');


      base.patient.downLoadPatientRebuyListReason(params).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('下载成功');
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleValid(e, part) {
      // console.log(e);
      // console.log(part);
      if (e === 2) {
        this.validate[`reason${part}`] = [
          {
            required: true, message: `请选择未复购原因${part}`, trigger: 'change', type: 'number',
          },
        ];
      } else {
        this.validate[`reason${part}`] = [
          { required: false },
        ];
        this.$refs.reasonForm.validateField(`reason${part}`);
      }
    },
    handleSubmit() {
      this.modalLoading = true;
      this.$refs.reasonForm.validate((valid) => {
        if (valid) {
          // console.log(this.reasonForm);
          base.patient.editPatientRebuyListReason(utils.handleParamsNoKeys(this.reasonForm)).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('修改成功');
              this.getData();
              this.editModal = false;
            } else {
              this.$Message.error(res.data.error);
            }
            this.modalLoading = false;
          }).catch((err) => {
            utils.handleError(err);
            this.modalLoading = false;
          });
        } else {
          this.modalLoading = false;
        }
      });
    },
    getData() {
      this.params = this.formatParams(this.query);
      const params = this.params;
      params.page = this.page;
      params.size = this.size;
      base.patient.getPatientRebuyListReason(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = res.data.data.list.map((item) => {
            item.recall1Str = this.$store.getters.getJudgeStr(item.recall1);
            item.recall2Str = this.$store.getters.getJudgeStr(item.recall2);
            item.recall3Str = this.$store.getters.getJudgeStr(item.recall3);
            item.reason1Str = this.$store.getters.getNoRebuyReasonStr(item.reason1);
            item.reason2Str = this.$store.getters.getNoRebuyReasonStr(item.reason2);
            item.reason3Str = this.$store.getters.getNoRebuyReasonStr(item.reason3);
            item.usageStartTime = utils.formatDate(item.usageStartTime);
            item.planRebuyTime = utils.formatDate(item.planRebuyTime);
            return item;
          });
          this.count = res.data.data.count;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    if (!this.handlePermission('editPatientRebuyListReason')) {
      this.columns.splice(this.columns.length - 1);
    }
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>

.btns{
  margin-bottom:8px
}
</style>
